
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/contact",
      function () {
        return require("private-next-pages/en/contact/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/contact"])
      });
    }
  